<template>
  <div class="get-start-section__left">
    <div class="get-start-section__title-copy">
      <div class="title-copy title-copy--left">
        <div class="tagline">
          <p class="t-overline tagline-text">Get Started Today</p>
        </div>
        <h1 class="h1 title-copy__title">
          Simply Stronger Security in Minutes
        </h1>
        <div class="b1 title-copy__copy wysiwyg">
          <p>
            Torq is a ground-up reinvention of what automation for security
            should be: automation that transforms how security teams work, by
            making it easier for them to deliver better protection, faster.
          </p>
        </div>
      </div>
    </div>
    <div class="get-start-section__benefits">
      <div class="get-start-section__benefit">
        <div class="get-start-section__benefit__left">
          <div class="get-start-section__benefit__icon">
            <div class="image image--contain anim--fade img-loaded">
              <img
                class="image-src entered loaded"
                src="placeholder.gif"
                data-sizes="100w"
                alt="Eliminate Repetitive Work Icon"
                data-ll-status="loaded"
                sizes="100w"
                srcset="
                  ./@/../../assets/icon-benifit-eliminate-repetitive-work.svg
                "
              />
            </div>
          </div>
        </div>
        <div class="get-start-section__benefit__right">
          <p class="h4 get-start-section__benefit__title">
            Eliminate Repetitive Work
          </p>
          <div class="get-start-section__benefit__divider"></div>
          <div class="get-start-section__benefit__copy">
            <p>
              Keep security teams focused on what matters most by automating any
              security task, no matter how big or small.
            </p>
          </div>
        </div>
      </div>
      <div class="get-start-section__benefit">
        <div class="get-start-section__benefit__left">
          <div class="get-start-section__benefit__icon">
            <div class="image image--contain anim--fade img-loaded">
              <img
                class="image-src entered loaded"
                src="placeholder.gif"
                data-sizes="100w"
                alt="Make the Right Decisions Icons"
                data-ll-status="loaded"
                sizes="100w"
                srcset="
                  ./@/../../assets/icon-benifit-make-the-right-decisions.svg
                "
              />
            </div>
          </div>
        </div>
        <div class="get-start-section__benefit__right">
          <p class="h4 get-start-section__benefit__title">
            Make the Right Decisions
          </p>
          <div class="get-start-section__benefit__divider"></div>
          <div class="get-start-section__benefit__copy">
            <p>
              Torq’s automation ensures that information is shared across
              systems and teams, so that human-in-the-loop processes happen fast
              and accurately.
            </p>
          </div>
        </div>
      </div>
      <div class="get-start-section__benefit">
        <div class="get-start-section__benefit__left">
          <div class="get-start-section__benefit__icon">
            <div class="image image--contain anim--fade img-loaded">
              <img
                class="image-src entered loaded"
                src="placeholder.gif"
                data-sizes="100w"
                alt="Deliver Stronger Security Icon"
                data-ll-status="loaded"
                sizes="100w"
                srcset="
                  ./@/../../assets/icon-benifit-deliver-stronger-security.svg
                "
              />
            </div>
          </div>
        </div>
        <div class="get-start-section__benefit__right">
          <p class="h4 get-start-section__benefit__title">
            Deliver Stronger Security
          </p>
          <div class="get-start-section__benefit__divider"></div>
          <div class="get-start-section__benefit__copy">
            <p>
              By reducing time spent on response, and accelerating remediation,
              Torq improves the security posture of the organization.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarketingContent",
};
</script>

<style scoped>
.get-start-section__left {
  padding: 0 60px 0 20%;
  width: 100vw;
  text-align: left;
}

.get-start-section__title-copy {
  max-width: 580px;
}

.get-start-section__benefits {
  margin-top: 73px;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.get-start-section__benefit {
  display: flex;
  flex-direction: row;
  max-width: 490px;
  width: 100%;

  &:not(:last-of-type) {
    margin-bottom: 54px;
  }
}

.get-start-section__benefit__icon {
  position: relative;
  height: 100px;
  width: 85px;
}

.get-start-section__benefit__title {
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  margin: 0 0 12px;
}

.get-start-section__benefit__right {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: left;
  margin-left: 50px;
}

.get-start-section__benefit__copy {
  max-width: 355px;
  text-align: left;
}

.t-overline {
  letter-spacing: 0.05em;
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
}
</style>
